import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App.jsx';
import { AuthProvider } from './auth/AuthContext.jsx';
import { ErrorBoundary } from './components/layout/ErrorBoundary.jsx';
import { CurrencyProvider } from './currency/CurrencyContext.jsx';
import { LanguageProvider } from './i18n/LanguageContext.jsx';
import { registriereServicearbeiter } from './pwa/registrieren.js';
import { ThemeProvider } from './theme/ThemeContext.jsx';
import './styles/global.css';
import './styles/charts.css';
import './styles/projects.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <LanguageProvider>
            <CurrencyProvider>
              <AuthProvider>
                {/* Die äussere Grenze. Die innere in der AppShell fängt den
                    Seiteninhalt ab; hier landet alles Übrige - die Hülle
                    selbst, die Anmeldeseite, der Anbieterbereich. Ohne sie
                    bliebe für diese Fälle die weisse Seite. */}
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
              </AuthProvider>
            </CurrencyProvider>
          </LanguageProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

/* NACH dem Zeichnen anmelden, nicht davor.
 *
 * Die Anmeldung ist ein Nebenweg: sie entscheidet darueber, ob sich die
 * Anwendung installieren laesst, nicht darueber, ob sie laeuft. Vor dem
 * ersten Bild angestossen, konkurriert sie mit dem Laden der Bauteile um
 * dieselbe Leitung und verzoegert genau das, worauf jemand wartet. */
registriereServicearbeiter();
